import React, { FC, ReactElement } from "react";

import { Circle } from "./styled";

import { PlaceholderIconProps } from "./types";

export const PlaceholderIcon: FC<PlaceholderIconProps> = ({ children, ready = true }) => {
  return ready ? <Circle /> : (children as ReactElement);
};
